import { useQuery } from '@tanstack/react-query';

import { serviceApi } from '~/features';
import { type CampaignResultsDetailedModelView } from '~/types';

export const GET_PRODUCTS_RESULTS_DETAILED_QUERY_KEY =
  'GET_PRODUCTS_RESULTS_DETAILED_QUERY';

export async function getProductsResultsDetailed(id: string) {
  return serviceApi.get<CampaignResultsDetailedModelView>(
    `/CalculoCampanhaProdutosPatrocinados/calculo-detalhado?CampaignId=${id}`
  );
}

export function useGetProductResultsDetailed(id: string) {
  return useQuery({
    queryKey: [GET_PRODUCTS_RESULTS_DETAILED_QUERY_KEY, id],
    queryFn: () => getProductsResultsDetailed(id),
    select: data => data.data,
  });
}
